import { styled } from "@mui/material";
import { shouldNotForwardProps } from "../../utils/shouldNotForwardProps.js";
const StyledSortingButton = styled(
  "button",
  shouldNotForwardProps(["sortValue"])
)(({ theme, sortValue }) => ({
  border: "none",
  width: "42px",
  height: "42px",
  cursor: "pointer",
  color: theme.palette.grey[400],
  backgroundColor: theme.palette.white.main,
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  path: {
    "&:first-of-type": {
      color: sortValue === "desc" ? theme.palette.grey[600] : "inherit"
    },
    "&:last-of-type": {
      color: sortValue === "asc" ? theme.palette.grey[600] : "inherit"
    }
  },
  "&:hover": {
    path: {
      color: theme.palette.grey[500]
    }
  }
}));
export {
  StyledSortingButton
};
//# sourceMappingURL=styles.js.map
